import React from 'react';
import PropTypes from 'prop-types';


function IfiContent(props) {
    const { templateContent, title } = props;
    return (
        <div className="content-container">
            <div className="content" dangerouslySetInnerHTML={ {__html: templateContent} }></div>
            <div className="label">Information from Industry</div>
            <div className="title" dangerouslySetInnerHTML={{__html: title} }></div>
        </div>
    )
}
IfiContent.propTypes = {
	templateContent: PropTypes.string,
	title: PropTypes.string
}

IfiContent.defaultProps = {
	templateContent: "",
	title: ""
}
export default IfiContent;